import styled from 'styled-components';
import { Tooltip } from '@mui/material';
import { ReactComponent as MinusIcon } from '../../assets/minus.svg';
import { ReactComponent as PlusIcon } from '../../assets/plus-3.svg';
import Button from '../Button';
import { tileStyles } from '../Button/styles';
import { Flex } from '../Flex';
import { radius, componentToken } from '../../style/utils';

type Size = 'small' | 'large';

const Wrapper = styled(Flex)<{ $size: Size }>`
  height: ${({ $size }) => ($size === 'large' ? 32 : 24)}px;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${componentToken('incrementSelector.border')};
  border-radius: ${radius('lg')};
  overflow: hidden;
`;

const ButtonWrapper = styled(Flex)`
  height: 100%;
`;

const ButtonStyled = styled(Button)<{ $size: Size }>`
  background: ${({ theme }) => theme.palette.surface.tinted};
  padding: 0;
  min-width: 0;
  width: 22px;
  height: 100%;
  border-radius: 0;

  :hover {
    background: ${({ theme }) => theme.palette.surface.strong};
  }

  path {
    fill: ${({ theme }) => theme.palette.icon.primary};
  }

  ${({ theme }) =>
    tileStyles(theme, {
      background: theme.palette.surface.tinted,
      hoverBackground: theme.palette.surface.strong,
      icon: theme.tokens.components.incrementSelector.icon,
    })}

  svg {
    ${({ $size }) => ($size === 'small' ? 'transform: scale(0.8);' : '')}
  }
`;

type Props = {
  onPlus: () => void;
  onMinus: () => void;
  disabled?: boolean;
  disablePlus?: boolean;
  disableMinus?: boolean;
  plusTooltip?: string;
  minusTooltip?: string;
  size?: Size;
  children: React.ReactNode;
  className?: string;
};

const IncrementSelector = ({
  children,
  onPlus,
  onMinus,
  disabled = false,
  disablePlus,
  disableMinus,
  plusTooltip,
  minusTooltip,
  size = 'large',
  className,
}: Props) => (
  <Wrapper $size={size} className={className}>
    <Tooltip title={minusTooltip} placement="top">
      <ButtonWrapper>
        <ButtonStyled
          $size={size}
          onClick={onMinus}
          disabled={disabled || disableMinus}
        >
          <MinusIcon />
        </ButtonStyled>
      </ButtonWrapper>
    </Tooltip>
    {children}
    <Tooltip title={plusTooltip} placement="top">
      <ButtonWrapper>
        <ButtonStyled
          $size={size}
          onClick={onPlus}
          disabled={disabled || disablePlus}
        >
          <PlusIcon />
        </ButtonStyled>
      </ButtonWrapper>
    </Tooltip>
  </Wrapper>
);

export default IncrementSelector;
